import { __awaiter, __extends, __generator } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { DOMAIN_TYPE_CHAT_MESSAGE, DOMAIN_TYPE_CHAT_THREAD, DOMAIN_TYPE_USER, } from '../../../../consts';
import { domainAction, domainSelector } from '../../../domain/domain-redux';
import { dispatchUiState } from '../../../domain/ui-state';
import { config } from '../../config';
import { selector } from '../../reducer';
import { url } from '../../url';
import { getClientConfig } from '../../utils/app-storage';
import { createDebugLogger } from '../../utils/app-utils';
import { I18nMsgNs } from '../../utils/i18n-helpers';
import { DefaultLayout } from '../Layout/DefaultLayout';
import { LayoutSegment } from '../Layout/LayoutSegment';
import './PageHome.scss';
var _isFn = function (v) { return typeof v === 'function'; };
var debug = createDebugLogger('PageHome');
var Msg = I18nMsgNs('PageHome');
var PageHomeClass = /** @class */ (function (_super) {
    __extends(PageHomeClass, _super);
    function PageHomeClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('PageHome');
        _this.submitCodeInput = function (value) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); };
        _this.onStartNewClick = function () {
            _this.props.history.replace(url.CHAT());
        };
        _this._tns = function (id, values, defaultMessage) {
            return _this.props.intl.formatMessage({ id: "PageHome.".concat(id), defaultMessage: defaultMessage }, values);
        };
        return _this;
    }
    PageHomeClass.resetStatics = function () {
        PageHomeClass.renderer = void 0;
        PageHomeClass.rendererMain = void 0;
        PageHomeClass.onInitialDataHandler = void 0;
        PageHomeClass.getInitialRoute = void 0;
    };
    PageHomeClass.prototype.componentDidMount = function () {
        var dispatch = this.props.dispatch;
        // reset na default, typicky PROJECT_TITLE
        dispatchUiState(dispatch, { header: null });
        // EXPERIMENTAL: garbage collect redux-state on each page home visit...
        // CORE MOTIVATION: keep the state as minimal as possible, due to new persistence
        // feature (JSON.stringify/parse volume optimization)
        // todo: if no edge cases found, move under "chatAction.chatGargeCollect" or similar
        dispatch(domainAction.resetDomainModelEnityType(DOMAIN_TYPE_CHAT_MESSAGE));
        dispatch(domainAction.resetDomainModelEnityType(DOMAIN_TYPE_CHAT_THREAD));
        // might cause issues if we'd store identity as a user domain model
        dispatch(domainAction.resetDomainModelEnityType(DOMAIN_TYPE_USER));
        // by default, we look for INITIAL_ROUTE in config
        var currentRoute = this.props.match.path;
        var route = (getClientConfig().INITIAL_ROUTE || '').trim();
        // but, if we have a custom route from externals, use it...
        if (typeof PageHomeClass.getInitialRoute === 'function') {
            var _route = PageHomeClass.getInitialRoute(this);
            if (_route !== void 0) {
                debug("Initial route via externals detected: ".concat(_route));
                route = _route;
            }
        }
        // do the actual "redirect"
        if (route && route !== currentRoute) {
            this.props.history.replace(route);
        }
    };
    PageHomeClass.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (typeof PageHomeClass.onInitialDataHandler === 'function' &&
            this.props.initialData &&
            this.props.initialData !== prevProps.initialData) {
            debug('Going to handle initial data', this.props.initialData);
            PageHomeClass.onInitialDataHandler(this, this.props.initialData);
        }
    };
    // ak nas rodicovsky kontajner (typicky nas zaujima iframe) je dislplay:none, tak
    // toto vrati false
    PageHomeClass.prototype.isVisible = function () {
        return this.ref && this.ref.offsetParent !== null;
    };
    PageHomeClass.prototype.render = function () {
        var _this = this;
        var B = config.css.B('-page-home');
        var rendererParams = {};
        var renderer = PageHomeClass.renderer, rendererMain = PageHomeClass.rendererMain;
        // completely external render?
        if (_isFn(renderer)) {
            return renderer(this, rendererParams);
        }
        var _renderMain = function () {
            return _isFn(rendererMain) ? (rendererMain(_this)) : (React.createElement(Button, { color: "primary", size: "lg", onClick: _this.onStartNewClick },
                React.createElement(Msg, { id: "startNew" })));
        };
        return (React.createElement(DefaultLayout, null,
            React.createElement(LayoutSegment, { label: "main" },
                React.createElement("div", { className: cn(B) }, _renderMain()))));
    };
    return PageHomeClass;
}(React.Component));
export { PageHomeClass };
var mapStateToProps = function (state, ownProps) {
    var initialData = domainSelector.getInitialData(state);
    return {
        identity: selector.identity.getIdentity(state),
        initialData: initialData,
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
export var PageHome = withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(PageHomeClass)));
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default PageHome;
